import React, { useEffect, useRef } from "react";
import Modal from "react-modal";
import { Helmet } from "react-helmet";
import { useState } from "react";

Modal.setAppElement("#root");

export const Logindemo = ({
  data,
  onShowQuotation,
  onShowICLIGMQuotation,
  signout = false,
  setSignout = () => {},
  setIquotAccessed = () => {},
  setQuotAccessed = () => {},
  isStandalone = false,
}) => {
  const [validUserId, setValidUserId] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userID, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [compregkeyid, setCompregkeyid] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [status, setStatus] = useState('');
  const [loginTrigger, setLoginTrigger] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loginMsgs, setLoginMsgs] = useState("Welcome");
  const [selectedDemo, setSelectedDemo] = useState('');
  const [baseUrl, setBaseUrl] = useState('');
  const [videos, setVideos] = useState([]);
  const [ratingModalIsOpen, setRatingModalIsOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const googleReviewLink = "https://g.page/r/CSzyRlLf6l0YEAI/review"; // put your real link
  const [sendMail, setSendMail] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [mapVideos, setMapVideos] = useState([]);
  const videoRef = useRef(null); // Create a ref for the video element
  const [successLogin, setSuccessLogin] = useState(false);
  const [lastRatingOpenTime, setLastRatingOpenTime] = useState(0);
  //console.log("onShowQuotation:", typeof onShowQuotation);
//console.log(window.location.pathname);
  //  const navigate = useNavigate();
  useEffect(() => {
    if (signout) {
      setSuccessLogin(false); // Reset successLogin state on signout
      console.log("Signout triggered");
    }
  }, [signout]);


  const ratingWindow = () => {
    //if already opened within last 5 minutes do not set to true
    const currentTime = new Date().getTime();
    if (currentTime - lastRatingOpenTime < 5 * 60 * 1000) {
      console.log("Rating window already opened within last 5 minutes.");
      closeModals(); // Close the modal if already opened
      return;
    }
    setLastRatingOpenTime(currentTime);
    setRatingModalIsOpen(true);
  };

  const closeModals = () => {
    setModalIsOpen(false);
    setRatingModalIsOpen(false);
    //    setVideos([]);
    setSelectedDemo("");
    setMapVideos([]);
    setRating(0);
    setShowAlert(false);
    setAlertMessage("");
    setLoading(false); // Hide loading message after completion
  };

  const submitRating = () => {
    if (rating > 0) {
      setLoading(true); // Show loading message

      let alertMessage = "Thank you for your feedback!";
      if (rating > 2) {
        alertMessage = `You rated us ${rating} stars! Please share this on Google to help others?`;
        //        alert(alert_msg);
        window.open(googleReviewLink);
      }
      // Display the alert message inside the modal
      setAlertMessage(alertMessage);
      setShowAlert(true);
      // Send feedback via email or API
      setSendMail(true);
    }
    setTimeout(() => {
      closeModals(); // Close the modal after 2 seconds
    }, 2000); // Example timeout for demo purposes
  };

  const validateUserId = (userId) => {
    // Regular expression for mobile validation
    const uiRegex = /^[ei][0-9]{3,5}$/;
    console.log(uiRegex.test(userId));
    return uiRegex.test(userId);
  };
  // Input change handler
  const handleInputChange = (event) => {
    const userId = event.target.value; // Get the input field value
    setUserId(userId); // Allow manual entry first
    const isValid = validateUserId(userId); // Validate the input

    if (isValid) {
      setValidUserId(true);
      setUserId(userId);
      console.log("User ID:", userId);
    } else {
      setValidUserId(false);
    }
  };

  const validatePwd = (pwd) => {
    // Regular expression for password validation
    const pwdRegex = /^[a-zA-Z ]{4}[0-9]{3,4}$/;
    console.log(pwdRegex.test(pwd));
    return pwdRegex.test(pwd);

  };
  // Input change handler
  const handlePwdChange = (event) => {
    const pwd = event.target.value; // Get the input field value
    setPassword(pwd); // Allow manual entry first
    const isValid2 = validatePwd(pwd); // Validate the input

    if (isValid2) {
      setValidPwd(true);
      setPassword(pwd);
    } else {
      setValidPwd(false);
    }
  };
  // LogIn trigger
  const handleLoginButton = (event) => {
    setLoginTrigger(true);
    console.log("Login Triggered with User ID:", userID, "and Password:", password);
  };
  // Demo button click handler
  const handleDemoButton = (event) => {
    console.log("Demo button clicked with User ID:", userID, "and Password:", password);
    if (successLogin) {
      console.log("Opening modal for demo videos...");
      setModalIsOpen(true);

    }
  };

  //demo video selection
  const handleSelectChange = (e) => {
    e.stopPropagation(); // Prevent event from bubbling
    setSelectedDemo(e.target.value); // Update dropdown value
    console.log("Modal State:", modalIsOpen);
    console.log("Selected Video:", e.target.value);
  };
  // Quotation button click handler
  const handleEMSSClick = () => {
     console.log({
    onShowQuotation,
    userID,
    compregkeyid,
    email,
    mobile,
    companyName
  });
    if (onShowQuotation && userID && compregkeyid && email && mobile && companyName) {
      onShowQuotation(userID, compregkeyid, email, mobile, companyName);
    }
  };

  const handleICLIGMClick = () => {
     console.log({
    onShowQuotation,
    userID,
    compregkeyid,
    email,
    mobile,
    companyName
  });
    if (onShowICLIGMQuotation && userID && compregkeyid && email && mobile && companyName) {
      onShowICLIGMQuotation(userID, compregkeyid, email, mobile, companyName);
    }
  };

  // mail send function
  const iclMail = "amar@eximon.com"; // for internal purpose only
  const EMAIL_THROTTLE_MS = 5 * 60 * 1000;
  useEffect(() => {
    async function sendMailfunc() {
      try {
        console.log("Aproaching mailsend API ...");

        let msub = "New Software Demo rating from " + companyName;
        let mbody = "New Software Demo rating from " + companyName + " with rating " + rating + " stars. Please check the feedback.<p>";
        mapVideos.forEach((video, index) => {
          mbody += `Video ${index + 1}:<br>`;
          mbody += `Source: ${video.src}<br>`;
          mbody += `Duration: ${video.duration} seconds</p>`;
        });
        const response = await fetch(`https://servguest.eximon.com/AndyCon?app=emailsend&email=${encodeURIComponent(iclMail)}&sub=${encodeURIComponent(msub)}&data=${encodeURIComponent(mbody)}`);

        if (!response.ok) {
          throw new Error('Network response was not OK');
        }
        const responseData = await response.text();
        // Process the responseData as needed
        console.log('mailsend Data received:', responseData);
        const lines = responseData.split('\n');

        let sqlflag = '';
        let email_sent = ''
        for (let line of lines) { //Data
          if (line.trim().startsWith("sqlflag")) {
            sqlflag = line.trim().substring(7);
            console.log("sqlflag:" + sqlflag);
          }
          if (line.trim().startsWith("email_sent")) {
            email_sent = line.trim().substring(10);
            console.log("email_sent:" + email_sent);
          }
        }
        if (sqlflag === 'true' && email_sent === 'true') {
          setSendMail(false);
          console.log("Mail sent successfully." + rating);
          localStorage.setItem("lastSentTo-" + iclMail, Date.now().toString());
        }
        else {
          console.error('API error: Mail response not received!');
        }
        // ✅ Save timestamp to localStorage

        closeModals(); // Close the modal after 2 seconds
      } catch (error) {
        console.error('API error:', error.message);
        closeModals(); // Close the modal after 2 seconds 
      }
    }
    //to make sure mail is not sent multiple times to same email
    if (sendMail) {
      //    sendMailfunc();
      const lastSent = localStorage.getItem(`lastSentTo-${iclMail}`);
      const now = Date.now();

      if (!lastSent || now - Number(lastSent) > EMAIL_THROTTLE_MS) {
        sendMailfunc();
      } else {
        console.warn("Email was already sent in the last 5 minutes. Skipping send.");
        //      setSendMail(false);
        setLoading(false);
        closeModals(); // Optionally close if skipped
      }
    } else {
      setLoading(false);
    }
  }, [sendMail, rating, userID, loading, companyName, mapVideos, EMAIL_THROTTLE_MS]);

  //Credentials check
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Aproaching API ..." + userID + " " + password + " " + loginTrigger);
        const response = await fetch(`https://servguest.eximon.com/AndyCon?app=Demo_videos&userid=${encodeURIComponent(userID)}&password=${encodeURIComponent(password)}`);

        if (!response.ok) {
          throw new Error('Network response was not OK');
        }
        const responseData = await response.text();
        // Process the responseData as needed
        console.log('Data received:', responseData);
        console.log('User:', userID);
        console.log('Password:', password);
        const lines = responseData.split('\n');
        let status = '';
        let sqlflag = '';
        let compkeyid = '0';
        for (let line of lines) { //Data
          if (line.trim().startsWith("sqlflag")) {
            sqlflag = line.trim().substring(7);
            console.log("sqlflag:" + sqlflag);
          }
          if (line.trim().startsWith("status")) {
            status = line.trim().substring(6);
            setStatus(status);
            console.log("Status:" + status);
          }
          if (line.trim().startsWith("company")) {
            console.log("Reading company:" + line.trim());
            let comp = line.trim().substring(7);
            setCompanyName(comp);
            console.log("Company:" + comp);
          }
          if (line.trim().startsWith("email")) {
            console.log("Reading email:" + line.trim());
            let email = line.trim().substring(5);
            setEmail(email);
            console.log("Email:" + email);
          }
          if (line.trim().startsWith("mobile")) {
            console.log("Reading mobile:" + line.trim());
            let mobile = line.trim().substring(6);
            setMobile(mobile);
            console.log("Mobile:" + mobile);
          }
          if (line.trim().startsWith("compregkeyid")) {
            compkeyid = line.trim().substring(12);
            setCompregkeyid(compkeyid);
            if (compkeyid === '' || compkeyid === '0') {
              setLoginMsgs('Invalid credentials');
              console.log("Invalid credentials");
            }
            else {
              setSuccessLogin(true);
              setSignout(false);
              console.log("Valid credentials");
            }
            console.log("Guest ID:" + compkeyid);
          }

        }

      } catch (error) {
        console.error('API error:', error.message);
      }
    };
    if (validPwd && validUserId && loginTrigger) {
      fetchData();
      setLoginTrigger(false);
    }
    else {
      console.log("Credential hook not triggered:", loginTrigger);
    }
  }, [validPwd, validUserId, password, userID, loginTrigger, setSignout]);

  //setting Modal 1
  useEffect(() => {
    const fetchData = async () => {
      //  setModalIsOpen(true);
      setLoginMsgs('Welcome');
      console.log("Modal window opened");
    };
    if (compregkeyid !== '' && compregkeyid !== '0') {
      fetchData();
    }
  }, [companyName, compregkeyid]);
  //fetch Videos
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("fetching videos of..." + status);
        let softName = 'ICLIGM';
        if (status === 'EE') {
          softName = 'EMSS';
          setBaseUrl('https://iclvideos.s3.ap-south-1.amazonaws.com/emss/');
        }
        else {
          softName = 'ICLIGM';
          setBaseUrl('https://iclvideos.s3.ap-south-1.amazonaws.com/icligm/');
        }
        const response = await fetch(`https://servguest.eximon.com/AndyCon?app=IR_iclvideos&software=${encodeURIComponent(softName)}`);
        const json = await response.json();
        const demoVideos = json.iclvideos.filter(video =>
          video.category === "Demos"
        );
        setVideos(demoVideos);

        //      groupDataByCategory(json.iclvideos);
        console.log("fetching completed.");
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    if (modalIsOpen) {
      fetchData();
    }
  }, [status, modalIsOpen]);

  useEffect(() => {
    console.log("Compregkeyid:", compregkeyid);
    console.log("userID:", userID);
  }, [successLogin, compregkeyid, userID]); // Logs when values change


  return (
    <div id="logindemo" className="text-center">
      {isStandalone && (
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Login - ICL Software Demos & Quotations</title>

        <link rel="canonical" href="https://eximon.com/logindemo" />

        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Login to ICL Software to generate quotations and access software demos for database, cloud, and AI chatbot solutions tailored to importers, exporters, and maritime companies."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Login - ICL Software Demos & Quotations" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://eximon.com/logindemo" />
        <meta
          property="og:description"
          content="Sign in to ICL Software to request quotations and explore demos of enterprise solutions for maritime, trade, and logistics businesses."
        />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Login - ICL Software Demos & Quotations" />
        <meta
          name="twitter:description"
          content="Login to ICL Software to generate quotations and access demos of enterprise solutions for importers, exporters, and maritime companies."
        />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
      </Helmet>
)}
      <div className="container">
        <div className="section-title" style={{ margin: "auto" }}>
          <h1>Sign In - ICL Software Demos</h1>
          <h2>Self help portal for ICL-Software services</h2>
          <p id='loginMsgs' style={{ textAlign: 'center', fontWeight: 'bold', color: '#ff791a' }}>{loginMsgs}</p>
        </div>

        <div className="form-group" style={{ display: "flex", alignItems: "center", margin: "auto" }}>

          {/* <img src="/img/SoftwareDemo_Cop.png" alt="ICL ChatBot" className="img-fluid" style={{ width: '30%', height: 'auto' }}/> */}

          <div className="form-container" style={{ width: "40%", margin: "auto" }}>
            <label htmlFor="userId" className="font-weight-bold text-light" style={{ fontSize: "16px", marginTop: "10px", fontWeight: "bold", color: "#ff791a", backgroundColor: "#000000" }}>
              User ID:
            </label>
            <input type="text" id="userId" className="form-control" placeholder="Enter User ID"
              value={userID}
              onChange={handleInputChange}
              style={{ borderColor: validUserId ? 'green' : '#cc5500' }}
            />

            <label htmlFor="password" className="font-weight-bold text-light" style={{ marginTop: "10px", fontSize: "16px", fontWeight: "bold", color: "#ff791a", backgroundColor: "#000000" }}>
              Password:
            </label>

            <input type="password" id="password" className="form-control" placeholder="Enter Password"
              value={password}
              onChange={handlePwdChange}
              style={{ borderColor: validPwd ? 'green' : '#cc5500' }}
            />
            <div className="btn-group" style={{ marginTop: "20px" }}>
              {(!successLogin || signout) && (<>
                <button className="btn btn-custom btn-md" onClick={handleLoginButton} >Log In</button>
                <a href="#contact" className="btn btn-custom btn-md">Sign up</a>
              </>)}
              {successLogin && !signout && !sendMail && (<>  <button className="btn btn-custom btn-md" onClick={handleDemoButton} >Demo</button>

                {userID.startsWith("e") && (<button className="btn btn-custom" onClick={handleEMSSClick}>
                  Quotation
                </button>
                )}
                {userID.startsWith("i") && (<button className="btn btn-custom" onClick={handleICLIGMClick}>
                  Quotation
                </button>
                )}

                {/* {userID.startsWith("e") && ( <button className="btn btn-custom" onClick={handleQuotClick}>
        Quotation
      </button>
 )} */}
                {/* {!userID.startsWith("e") && ( */}
                <button
                  className="btn btn-custom"
                  onClick={() => {
                    setSuccessLogin(false);
                    setSignout(true);
                    setIquotAccessed(false);
                    setQuotAccessed(false);
                  }}
                >
                  Sign out
                </button>
                {/* )} */}
              </>
              )};
            </div>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={ratingWindow}
              style={{
                content: {
                  position: 'absolute',
                  top: '100px',
                  left: '80px',
                  right: 'auto',
                  bottom: 'auto',
                  width: '80%',
                  height: '80%'
                }
              }}
            >
              {loading && <div style={{ fontWeight: "bold" }}>Please wait loading ...</div>}
              <div style={{ marginTop: '2px', alignItems: 'center', textAlign: 'center' }}>
                <h3>Welcome {companyName}</h3>
                <p style={{ marginTop: '4px' }}>Please select a demo to play:</p>

                <select id="dropdown" value={selectedDemo}
                  onChange={handleSelectChange}
                  // onChange={(e) => setSelectedDemo(e.target.value)} 
                  style={{ marginLeft: '10px' }}>
                  <option value="">--Select a Video--</option>
                  {videos.map((video) => (
                    <option key={video.keyid} value={video.video}>
                      {video.caption}
                    </option>
                  ))}
                </select>

                {/* {selectedDemo && <p>You selected: {selectedDemo}</p>} */}
              </div>
              {selectedDemo && (
                <video
                  ref={videoRef}
                  src={`${baseUrl}${selectedDemo}`}
                  controls
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()} // Blocks right-click
                  onCopy={(e) => e.preventDefault()} // Blocks copying
                  style={{ width: '100%', height: '80%', marginTop: '10px', marginBottom: '10px' }}
                  onLoadedMetadata={() => {
                    setLoading(false);
                    const videoElement = videoRef.current; // Safely access the video element
                    if (videoElement) {
                      const duration = videoElement ? videoElement.duration : 0; // Get the duration if the element exists
                      setMapVideos((prevVideos) => {
                        const newVideos = [...prevVideos, { src: selectedDemo, duration }];
                        return newVideos;
                      });
                    }
                  }
                  }
                >
                  Your browser does not support the video tag. {compregkeyid}
                </video>
              )}
              {!loading &&
                <button onClick={ratingWindow} type="button" className="btn btn-custom btn-lg" style={{ marginTop: '5px' }}>
                  Close
                </button>
              }
            </Modal>
          </div>
          {/* Rating Modal */}
          <Modal
            isOpen={ratingModalIsOpen}
            onRequestClose={() => setRatingModalIsOpen(false)}
            style={{
              content: {
                position: 'absolute',
                top: '200px',
                left: '100px',
                width: '400px',
                height: '300px',
              }
            }}
          >

            <h3>How would you rate your EMSS Software Demo experience?</h3>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  onClick={() => setRating(star)} // Set rating only
                  style={{
                    fontSize: "24px",
                    cursor: "pointer",
                    color: rating >= star ? "gold" : "gray",
                  }}
                >
                  ★
                </span>
              ))}

            </div>
            <div className="btn-group" style={{ marginTop: "20px" }}>
              {loading && <div style={{ fontWeight: "bold" }}>Please wait ...</div>}
              <button className="btn btn-custom btn-lg" onClick={submitRating} style={{ marginTop: '20px' }}>
                Submit Rating
              </button>
              <button
                className="btn btn-custom btn-lg"
                onClick={() => {
                  setLoading(true); // Show loading message
                  setSendMail(true); // Trigger mail sending
                  closeModals(); // Close the modal
                }}
                style={{ marginTop: "20px" }}
              >
                Skip
              </button>
            </div>
            {ratingModalIsOpen && (
              <div className="modal">
                <div className="modal-content">
                  <h3>Feedback</h3>
                  {showAlert && <div className="alert">{alertMessage}</div>}
                  {/* Other modal content */}
                </div>
              </div>
            )}

          </Modal>
        </div>
      </div>
    </div>

  );
};
